module.exports = __webpack_public_path__ + "static/media/10_showesportes_mobile.f9c244dc.jpg";